export function initMainMenu(mainMenu: HTMLElement) {

	let openers = mainMenu.querySelectorAll<HTMLButtonElement>('[data-part="opener"]');
	let closer = mainMenu.querySelector<HTMLButtonElement>('[data-part="closer"]');
	let menu = mainMenu.querySelector<HTMLDialogElement>('[data-part="menu"]');

	openers?.forEach(
		(opener: HTMLButtonElement) => {
			opener.addEventListener('click', () => {
				if (menu) {

					if (menu.open) {
						menu.close();
					} else {
						menu.show();
					}
					mainMenu.classList.toggle('submenu-open', menu.open);

					if (menu.open) {
						setTimeout(
							() => {
								menu.querySelector('a').focus();
							},
							100
						);
					}
				}
			})
		}
	);

	closer?.addEventListener('click', () => {
		if (menu) {
			menu.close();
			mainMenu.classList.remove('submenu-open');
			opener.focus();
		}
	});

	window.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && menu?.open) {
			menu.close();
			opener.focus();
			mainMenu.classList.remove('submenu-open');
		}
	})

}
